import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {firstValueFrom, forkJoin, Observable} from "rxjs";
import {ChatService} from "../../../services/chat.service";
import {IChatResponse} from "../../../shared/interfaces/chat";
import {InputTextareaModule} from "primeng/inputtextarea";
import {FormsModule} from "@angular/forms";
import {SkeletonModule} from "primeng/skeleton";
import {ChartModule} from "primeng/chart";
import {ChatComponent} from "../chat-components/chat/chat.component";
import {MessageService} from "primeng/api";

@Component({
  selector: 'app-chat-ia',
  standalone: true,
  imports: [
    InputTextareaModule,
    FormsModule,
    SkeletonModule,
    ChartModule,
    ChatComponent,
  ],
  template: `
  <div class="dash-page">
    <app-chat [title]="this.translation.title"/>
  </div>  
  `,
  styleUrl: './chat-ia.component.scss'
})
export class ChatIaComponent implements OnInit {
  translation: any = {};
  response: IChatResponse | string | undefined = undefined;
  readonly BACKGROUND = '#eceff4';

  @ViewChild(ChatComponent, {static: true}) chatComponent!: ChatComponent;

  constructor(private _t: TranslateService,
              private messageService: MessageService,
              private chatService: ChatService) {
  }


  ngOnInit(): void {
    this.translations().then();
    this.chatComponent.requestMethod$ = this.chatService.simpleResponseTramites.bind(this.chatService);
  }

  async translations() {
    this.translation = await firstValueFrom(forkJoin({
      title: this._t.get('components.app-chat.title'),
      respuesta: this._t.get('components.app-chat.respuestas'),
      send: this._t.get('components.app-chat.send'),
      reload: this._t.get('components.app-chat.reload'),
      advertencia: this._t.get('common.advertencia'),
      errorGeneral: this._t.get('components.app-chat.error-general'),
      descripcionCampo: this._t.get('components.app-chat.title-input'),
    }))
  }
}
